import { DropDownChip, DropDownChipProps } from '@replai-platform/ui-components';

export interface CampaignFilterProps {
  disabled?: boolean;
  options: DropDownChipProps['dropDownOptions'];
  onChange: DropDownChipProps['onChange'];
  loading: boolean;
  dropdownMaxHeightInVH?: number;
}

const CampaignFilter: React.VFC<CampaignFilterProps> = ({
  disabled,
  options,
  onChange,
  loading,
  dropdownMaxHeightInVH,
}) => (
  <DropDownChip
    disabled={disabled}
    data-test="filter-campaign-dropdown"
    placeHolder="Select Campaign"
    defaultOption="All Campaigns"
    dropDownType="multiselect"
    dropDownOptions={options}
    dropDownAlignment="right"
    onChange={onChange}
    prefixLabel="Campaigns"
    loading={loading}
    dropdownMaxHeightInVH={dropdownMaxHeightInVH}
  />
);

export default CampaignFilter;
